import { render, staticRenderFns } from "./HealthReportSurveillanceReasonView.vue?vue&type=template&id=0168c521&"
import script from "./HealthReportSurveillanceReasonView.vue?vue&type=script&lang=js&"
export * from "./HealthReportSurveillanceReasonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports